import { register, getPrefix } from '../../../Utils'
const SignaturePad = require('signature_pad')

const SignatureField = el => {
  const prefix = getPrefix(el)
  const wrapper = document.querySelector(`.${prefix}signature-field`)
  const clearButton = wrapper.querySelector(`.${prefix}clear`)
  const canvas = wrapper.querySelector('canvas')
  const signatureInput = wrapper.querySelector(`.${prefix}signature-input`)
  const signaturePad = new SignaturePad.default(canvas, {
    backgroundColor: 'rgb(255, 255, 255)'
  })

  clearButton.addEventListener('click', function (event) {
    signaturePad.clear()
  })

  signaturePad.addEventListener('endStroke', () => {
    signatureInput.value = signaturePad.toDataURL()
  }, { once: false })

  const resizeCanvas = () => {
    const ratio =  Math.max(window.devicePixelRatio || 1, 1)
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)
    signaturePad.fromData(signaturePad.toData())
  }

  window.addEventListener('resize', resizeCanvas)
  resizeCanvas()
}

register('SignatureField', SignatureField)
